export default "/judging";
